import React, {Component} from "react";
import { compose } from 'redux';
import { withRouter, Link } from "react-router-dom";
import {connect} from "react-redux";
import {
	is
} from "ramda";
import { css } from 'emotion';
import { gridGutterHalf } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import OrderResume from "../OrderResume";
import {
    checkoutCredentials,
    redirectAfterLogout,
    redirectToLogin
} from "../../../shared/utils";
import MyAccountMenu from "../MyAccountMenu";
import {
    logoutUser,
    pingUser,
} from "../../../shared/requests-api";
import LuggageCard from "./luggage/LuggageCard";
import DetailsCancellationRow from "./DetailsCancellationRow";
import DetailsPurchaseResume from "./DetailsPurchaseResume";
import FlightResume from "../FlightResume";
import HotelLink from "../hotel/hotelLink";

const detailsItemWrapper = css`
    margin-top: ${gridGutterHalf}px;
`;

class DetailsWrapper extends Component {
    constructor() {
        super();
    }

    componentWillMount() {
        const token = checkoutCredentials().au;
        const self = this;

        //Checa se o usuário está logado e redireciona adequadamente
        if (token) {
            pingUser(token)
                .then(response => {
                    if (!response.data.success) {
                        logoutUser()
                            .then(() => {
                                redirectAfterLogout(window);
                            })
                            .catch(error => {
                                redirectToLogin(window);
                                reject(error);
                            });
                    } else {
                        if (self.props.cancellation.orderToDetail === null || typeof self.props.cancellation.orderToDetail === 'undefined')
                            this.props.history.push('/cliente/minhas-viagens-light');
                    }
                })
                .catch(error => {
                    redirectToLogin(window);
                    reject(error);
                });
        } else {
            redirectToLogin(window);
        }
    }

    render() {
        const { cancellation: { orderToDetail : order } } = this.props;
        const {eticket, status} = order.order;
        return (
            <div id="detailsPage" className="tripspage container">
                <div className="row">
                    <aside className="col-xs-16 col-md-4">
                        <MyAccountMenu/>
                    </aside>

                    <div className="container">
                    <section className="col-xs-16 col-md-12">
                        <div className="return-row">
                            <i className="icon icon-arrow-left return-icon"/>
                            <Link
                                to="/cliente/minhas-viagens-light"
                                title="Voltar"
                                className="return-text"
                                data-action="my-trips-details-page-return"
                            >
                                Voltar
                            </Link>
                        </div>
                        <div className="row">
                            <div className={detailsItemWrapper}>
                                <div className="col-xs-16">
                                    <h1 className="subtitle">Detalhes da compra</h1>
                                    <div className="new-card">
                                        <div className="new-card__content">
                                            <div className="details-wrapper">
                                                <OrderResume order={is(Object, order) ? order.order : undefined}/>
                                                <FlightResume
                                                    flights={order.flights}
                                                    passengers={order.passengers}
                                                />
                                            </div>
                                            <div className="dashed-ruller details-wrapper">
                                                <DetailsCancellationRow order={order}/>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        (status === "APROVADO" || status === "AGUARDANDO") && (
                                            <div className="flight-resume-hotel-link-wrapper">
                                                <HotelLink trip={order} flagValidatorName="FLAG_HAS_BEEN_SEEN_RESUME" dataAction="hotel-link-my-trips-resume" />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={detailsItemWrapper}>
                                <div className="col-xs-16">
                                    <h2 className="subtitle">Resumo da compra</h2>
                                    <DetailsPurchaseResume purchase={is(Object, order) ? order : undefined} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={detailsItemWrapper}>
                                <div className="col-xs-16">
                                    <LuggageCard order={order}/>
                                </div>
                            </div>
                        </div>
                    </section>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
	cancellation: state.cancellation
});

const mapDispatchToProps = dispatch => ({
	setUserOrders: orders => dispatch(setOrders(orders)),
	setOrderToCancel: orderObj => dispatch(setOrderToCancel(orderObj))
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(DetailsWrapper);
